import locales from "../locales/locales";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { dotMotion } from "../animations/framer";
import { changeLocale } from "../app/features/locale/localeSlice";

const style = {
	navbar: `bg-dark text-white h-[60px] flex items-center justify-center px-4`,
	selector: `relative flex items-center gap-4`,
	switchDot: `w-[30px] height-[30px] drop-shadow-xl bg-white rounded-full`,
};

const Navbar = () => {
	const dispatch = useDispatch();
	const { currentLocale } = useSelector((state) => state.locale);
	const localeToggler = () => {
		if (currentLocale === locales.RU) {
			dispatch(changeLocale(locales.EN));
		} else {
			dispatch(changeLocale(locales.RU));
		}
	};
	return (
		<nav className={style.navbar}>
			<div className={style.selector}>
				<p>Lotincha</p>
				<div
					onClick={localeToggler}
					className={`w-[60px] h-[30px] bg-blue flex transition-colors duration-500 ${
						currentLocale === locales.EN
							? "justify-start bg-blue"
							: "justify-end bg-red"
					} rounded-full cursor-pointer`}
				>
					<motion.div
						layout
						transition={dotMotion}
						className={style.switchDot}
					></motion.div>
				</div>
				<p>Кириллча</p>
			</div>
		</nav>
	);
};

export default Navbar;
